import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Typography,
    TextField,
  } from "@mui/material";
  import IconButton from "@mui/material/IconButton";
  import CloseIcon from "@mui/icons-material/Close";
  import React, { Fragment, useState, useEffect } from "react";
  import moment from "moment";
//   import { updateAlertStatus } from "../../../apis/MoMs";
//   import { API_URL } from "../../../config";
//   const MOMS_IMAGE_URL = `${process.env.REACT_APP_STORAGE_URL}`;
import { STORAGE_URL } from "../../../config";
  
  function MomsImageModal(props) {
    const { momsImage, featureName, setOpenModal, isOpen } = props;
    const [moms_image, setMomsImage] = useState(null);
    console.log(momsImage);
    const closeModal = () => {
      setOpenModal(false);
    };
  
    return (
      <Dialog
        fullWidth
        fullScreen={false}
        open={isOpen}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {featureName}
          <IconButton
            aria-label="close"
            onClick={() => {
              setOpenModal(false);
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Fragment item md={12}>
            {momsImage ? (
              <img
                src={`${STORAGE_URL}/storage/moms/${momsImage}`}
                alt={"moms image"}
                height="auto"
                width="100%"
              />
            ) : (
              <p>No image uploaded</p>
            )}
          </Fragment>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModal} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
  
  export default MomsImageModal;
  